export default "__VITE_ASSET__01dda77e__"